import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  statsCard: {
    flex: '1 1 calc(60% - 24px)',
    maxWidth: 'calc(60% - 24px)',
    width: '100%'
  },
  statsCardSmaller: {
    flex: '1 1 calc(20% - 24px)',
    maxWidth: 'calc(20% - 24px)',
    width: '100%'
  },
  statusTag: {
    width: 128,
    height: 32,
    textAlign: 'center',
    alignContent: 'center'
  }
}))
